function NXRocket({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M5.71 4.3099C3.79 2.9999 2 3.9999 0.5 5.5399L3.82 7.5399"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.69002 8.29004C11 10.21 10 12 8.46002 13.5L6.46002 10.18"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.82001 7.5301L6.47001 10.1801C8.59001 8.91009 11 7.68009 12.1 6.54009C14.48 4.16009 13.1 0.900095 13.1 0.900095C13.1 0.900095 9.84001 -0.479905 7.46001 1.90009C6.32001 3.00009 5.08001 5.4201 3.82001 7.5301Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.28003 5.02002L8.98003 8.72002"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 4C10.7761 4 11 3.77614 11 3.5C11 3.22386 10.7761 3 10.5 3C10.2239 3 10 3.22386 10 3.5C10 3.77614 10.2239 4 10.5 4Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.68 12.4399C3.1 12.9999 0.5 13.4999 0.5 13.4999C0.5 13.4999 1 10.8999 1.56 10.3199C1.69732 10.1726 1.86292 10.0544 2.04692 9.97238C2.23092 9.8904 2.42955 9.84632 2.63095 9.84276C2.83236 9.83921 3.03242 9.87626 3.2192 9.9517C3.40597 10.0271 3.57564 10.1394 3.71808 10.2819C3.86051 10.4243 3.9728 10.594 4.04825 10.7808C4.12369 10.9675 4.16074 11.1676 4.15718 11.369C4.15363 11.5704 4.10955 11.769 4.02756 11.953C3.94558 12.137 3.82737 12.3026 3.68 12.4399Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXRocket;
